// test2794
(2794 && 0);
